import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import type { Header } from '@tanstack/react-table';

import { sortIconClasses } from './classes';

export const isHeaderDraggable = <TData, TValue>(header: Header<TData, TValue>) =>
  !header.column.getIsPinned() && header.id !== 'toggleSubRows';

export const renderSortIcon = (sortDirection: string | false) => {
  if (sortDirection === 'asc') {
    return <ChevronUpIcon className={sortIconClasses({ isSorted: true })} aria-hidden="true" />;
  }

  if (sortDirection === 'desc') {
    return <ChevronDownIcon className={sortIconClasses({ isSorted: true })} aria-hidden="true" />;
  }

  return <ChevronDownIcon className={sortIconClasses({ isSorted: false })} aria-hidden="true" />;
};
